import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from "react";
//key Begin
const FIRST_LOGIN_KEY = "first-login-user";
const VISITED_LIST_DEVICES_KEY = "visited-list-devices";
const ADDED_NEW_DEVICE_KEY = "added-new-device";
const VISITED_LIST_OPERATIONS_KEY = "visited-list-operation";
const ADDED_NEW_OPERATION_KEY = "added-new-operation";
const VISITED_LIST_DEVICE_SERIALS_KEY = "visited-list-device-serials";
const ADDED_NEW_DEVICE_SERIALS_KEY = "added-new-device-serial";
const VISITED_LIST_DEVICE_MESSAGE_KEY = "visited-list-device-message";
const ADDED_NEW_DEVICE_MESSAGE_KEY = "added-new-device-message";
const VISITED_ANALYZE_LABORATORY_KEY = "visited-analyze-laboratory";
const ADDED_NEW_ANALYZE_FILE_KEY = "added-new-analyze-file";
const VISITED_GENERATE_LABORATORY_KEY = "visited-generate-laboratory";
const ADDED_NEW_GENERATE_FILE_KEY = "added-new-generate-file";
const VISITED_SEND_VERIFY_ACCESS_KEY = "visited-send-verify-access";
const VISITED_FILE_MANAGER_LIST = "visited-file-manager-list";
const VISITED_ANALYZER_OVERVIEW = "visited-analyzer-overview";
const VISITED_DEVICE_UPDATE_LIST = "visited-device-update-list";
const VISITED_VERIFY_ACCESS_KEY = "visited-verify-access";
const VISITED_MQTT_CONNECTION_KEY = "visited-mqtt-connection";
const VISITED_SETTING_LABORATORY_KEY = "visited-setting-laboratory";
const VISITED_HISTORY_LABORATORY_KEY = "visited-history-laboratory";
const ADDED_NEW_TICKET_KEY = "added-new-ticket";
const VISITED_TICKET_LIST_KEY = "visited-ticket-list";
const VISITED_SEND_VERIFY_ACCESS_LOCATION_KEY = "visited-send-verify-access-location";
const VISITED_VERIFY_ACCESS_LOCATION_KEY = "visited-verify-access-location";
const VISITED_DEVICE_HISTORY_LOCATION_KEY = "visited-device-history-location";
const VISITED_DEVICE_CONTROL_LOCATION_KEY = "visited-device-control-location";
const VISITED_DEVICE_REQUEST_SMS_SENT_KEY = "visited-device-request-sms-sent";
const VISITED_LACK_OF_WALLET_DEVICE_REQUEST_SMS_SENT_KEY = "visited-lack-of-wallet-device-request-sms-sent";
const SHOW_DOWNLOAD_LINK = "show-download-link";

//key End

//interface Begin
interface FirstLoginContextType {
  isFirstLogin: boolean;
  setFirstLoginStatus: (status: boolean) => void;
  hasVisitedListDevices: boolean;
  setVisitedListDevices: (status: boolean) => void;
  hasAddedNewDevice: number;
  setAddedNewDevice: (status: number) => void;
  hasAddedNewOperation: number;
  setAddedNewOperation: (status: number) => void;
  hasVisitedListOperations: boolean;
  setVisitedListOperations: (status: boolean) => void;
  hasAddedNewDeviceSerial: number;
  setAddedNewDeviceSerial: (status: number) => void;
  hasVisitedListDeviceSerials: boolean;
  setVisitedListDeviceSerials: (status: boolean) => void;
  hasAddedNewDeviceMessage: number;
  setAddedNewDeviceMessage: (status: number) => void;
  hasVisitedListDeviceMessage: boolean;
  setVisitedListDeviceMessage: (status: boolean) => void;
  hasAddedNewAnalyzeFile: number;
  setAddedNewAnalyzeFile: (status: number) => void;
  hasVisitedAnalyzeLaboratory: boolean;
  setVisitedAnalyzeLaboratory: (status: boolean) => void;
  hasAddedNewGenerateFile: number;
  setAddedNewGenerateFile: (status: number) => void;
  hasVisitedGenerateLaboratory: boolean;
  setVisitedGenerateLaboratory: (status: boolean) => void;
  hasVisitedSendVerifyAccess: boolean;
  setVisitedSendVerifyAccess: (status: boolean) => void;
  hasVisitedVerifyAccess: boolean;
  setVisitedVerifyAccess: (status: boolean) => void;
  hasVisitedMqttConnection: boolean;
  setVisitedMqttConnection: (status: boolean) => void;
  hasVisitedSettingLaboratory: boolean;
  setVisitedSettingLaboratory: (status: boolean) => void;
  hasVisitedHistoryLaboratory: boolean;
  setVisitedHistoryLaboratory: (status: boolean) => void;
  hasAddedNewTicket: number;
  setAddedNewTicket: (status: number) => void;
  hasVisitedTicketList: boolean;
  setVisitedTicketList: (status: boolean) => void;
  hasVisitedSendVerifyAccessLocation: boolean;
  setVisitedSendVerifyAccessLocation: (status: boolean) => void;
  hasVisitedVerifyAccessLocation: boolean;
  setVisitedVerifyAccessLocation: (status: boolean) => void;
  hasVisitedDeviceHistoryLocation: boolean;
  setVisitedDeviceHistoryLocation: (status: boolean) => void;
  hasVisitedDeviceControlLocation: boolean;
  setVisitedDeviceControlLocation: (status: boolean) => void;
  hasVisitedDeviceRequestSMSSent: boolean;
  setVisitedDeviceRequestSMSSent: (status: boolean) => void;
  hasVisitedLackOfWalletDeviceRequestSMSSent: boolean;
  setVisitedLackOfWalletDeviceRequestSMSSent: (status: boolean) => void;
  hasVisitedFileManagerList: boolean;
  setVisitedFileManagerList: (status: boolean) => void;
  hasVisitedAnalyzerOverview: boolean;
  setVisitedAnalyzerOverview: (status: boolean) => void;
  hasVisitedDeviceUpdateList: boolean;
  setVisitedDeviceUpdateList: (status: boolean) => void;
  showDownloadLink: boolean;
  setShowDownloadLinkValue: (status: boolean) => void;
}
//interface End
const FirstLoginContext = createContext<FirstLoginContextType | undefined>(
  undefined
);

interface FirstLoginProviderProps {
  children: ReactNode;
}

export const useFirstLogin = () => {
  const context = useContext(FirstLoginContext);
  if (!context) {
    throw new Error("must use hook with Provider");
  }
  return context;
};

export const TourGuideProvider: React.FC<FirstLoginProviderProps> = ({
  children,
}) => {
  const [isFirstLogin, setIsFirstLogin] = useState<boolean>(() => {
    const storedFirstLogin = localStorage.getItem(FIRST_LOGIN_KEY);
    return storedFirstLogin == "true" ? true : false;
  });
  const [hasVisitedListDevices, setHasVisitedListDevices] = useState<boolean>(
    () => {
      const storedVisitedListDevices = localStorage.getItem(
        VISITED_LIST_DEVICES_KEY
      );

      return storedVisitedListDevices == "true" ? true : false;
    }
  );
  const [hasAddedNewDevice, setHasAddedNewDevice] = useState<number>(() => {
    const storedAddedNewDevice = localStorage.getItem(ADDED_NEW_DEVICE_KEY);
    return storedAddedNewDevice == "2"
      ? 2
      : storedAddedNewDevice == "1"
        ? 1
        : 0;
  });

  const [hasAddedNewOperation, setHasAddedNewOperation] = useState<number>(
    () => {
      const storedAddedNewOperation = localStorage.getItem(
        ADDED_NEW_OPERATION_KEY
      );
      return storedAddedNewOperation == "2"
        ? 2
        : storedAddedNewOperation == "1"
          ? 1
          : 0;
    }
  );

  const [hasVisitedListOperations, setHasVisitedListOperations] =
    useState<boolean>(() => {
      const storedVisitedListOperations = localStorage.getItem(
        VISITED_LIST_OPERATIONS_KEY
      );
      return storedVisitedListOperations == "true" ? true : false;
    });

  const [hasAddedNewDeviceSerial, setHasAddedNewDeviceSerial] =
    useState<number>(() => {
      const storedAddedNewDeviceSerial = localStorage.getItem(
        ADDED_NEW_DEVICE_SERIALS_KEY
      );
      return storedAddedNewDeviceSerial == "2"
        ? 2
        : storedAddedNewDeviceSerial == "1"
          ? 1
          : 0;
    });

  const [hasVisitedListDeviceSerials, setHasVisitedListDeviceSerials] =
    useState<boolean>(() => {
      const storedVisitedListDeviceSerials = localStorage.getItem(
        VISITED_LIST_DEVICE_SERIALS_KEY
      );
      return storedVisitedListDeviceSerials == "true" ? true : false;
    });

  const [hasAddedNewDeviceMessage, setHasAddedNewDeviceMessage] =
    useState<number>(() => {
      const storedAddedNewDeviceMessage = localStorage.getItem(
        ADDED_NEW_DEVICE_MESSAGE_KEY
      );
      return storedAddedNewDeviceMessage == "2"
        ? 2
        : storedAddedNewDeviceMessage == "1"
          ? 1
          : 0;
    });

  const [hasVisitedListDeviceMessage, setHasVisitedListDeviceMessage] =
    useState<boolean>(() => {
      const storedVisitedListDeviceMessage = localStorage.getItem(
        VISITED_LIST_DEVICE_MESSAGE_KEY
      );

      return storedVisitedListDeviceMessage == "true" ? true : false;
    });
  const [hasAddedNewAnalyzeFile, setHasAddedNewAnalyzeFile] = useState<number>(
    () => {
      const storedAddedNewAnalyzeFile = localStorage.getItem(
        ADDED_NEW_ANALYZE_FILE_KEY
      );
      return storedAddedNewAnalyzeFile == "2"
        ? 2
        : storedAddedNewAnalyzeFile == "1"
          ? 1
          : 0;
    }
  );
  const [hasVisitedAnalyzeLaboratory, setHasVisitedAnalyzeLaboratory] =
    useState<boolean>(() => {
      const storedVisitedAnalyzeLaboratory = localStorage.getItem(
        VISITED_ANALYZE_LABORATORY_KEY
      );
      return storedVisitedAnalyzeLaboratory == "true" ? true : false;
    });
  const [hasAddedNewGenerateFile, setHasAddedNewGenerateFile] =
    useState<number>(() => {
      const storedAddedNewGenerateFile = localStorage.getItem(
        ADDED_NEW_GENERATE_FILE_KEY
      );
      return storedAddedNewGenerateFile == "2"
        ? 2
        : storedAddedNewGenerateFile == "1"
          ? 1
          : 0;
    });
  const [hasVisitedGenerateLaboratory, setHasVisitedGenerateLaboratory] =
    useState<boolean>(() => {
      const storedVisitedGenerateLaboratory = localStorage.getItem(
        VISITED_GENERATE_LABORATORY_KEY
      );
      return storedVisitedGenerateLaboratory == "true" ? true : false;
    });
  const [hasVisitedSendVerifyAccess, setHasVisitedSendVerifyAccess] =
    useState<boolean>(() => {
      const storedVisitedSendVerifyAccess = localStorage.getItem(
        VISITED_SEND_VERIFY_ACCESS_KEY
      );
      return storedVisitedSendVerifyAccess == "true" ? true : false;
    });
  const [hasVisitedFileManagerList, setHasVisitedFileManagerList] =
    useState<boolean>(() => {
      const storedVisitedFileManagerList = localStorage.getItem(
        VISITED_FILE_MANAGER_LIST
      );
      return storedVisitedFileManagerList == "true" ? true : false;
    });

  const [hasVisitedAnalyzerOverview, setHasVisitedAnalyzerOverview] =
    useState<boolean>(() => {
      const storedVisitedAnalyzerOverview = localStorage.getItem(
        VISITED_ANALYZER_OVERVIEW
      );
      return storedVisitedAnalyzerOverview == "true" ? true : false;
    });

    const [hasVisitedDeviceUpdateList, setHasVisitedDeviceUpdateList] =
    useState<boolean>(() => {
      const storedVisitedDeviceUpdateList = localStorage.getItem(
        VISITED_DEVICE_UPDATE_LIST
      );
      return storedVisitedDeviceUpdateList == "true" ? true : false;
    });

    const [showDownloadLink, setShowDownloadLink] =
    useState<boolean>(() => {
      const showDownloadLink = localStorage.getItem(
        SHOW_DOWNLOAD_LINK
      );
      return showDownloadLink == "true" ? true : false;
    });

  const [hasVisitedVerifyAccess, setHasVisitedVerifyAccess] = useState<boolean>(
    () => {
      const storedVisitedVerifyAccess = localStorage.getItem(
        VISITED_VERIFY_ACCESS_KEY
      );
      return storedVisitedVerifyAccess == "true" ? true : false;
    }
  );
  const [hasVisitedMqttConnection, setHasVisitedMqttConnection] =
    useState<boolean>(() => {
      const storedVisitedMqttConnection = localStorage.getItem(
        VISITED_MQTT_CONNECTION_KEY
      );
      return storedVisitedMqttConnection == "true" ? true : false;
    });
  const [hasVisitedSettingLaboratory, setHasVisitedSettingLaboratory] =
    useState<boolean>(() => {
      const storedVisitedSettingLaboratory = localStorage.getItem(
        VISITED_SETTING_LABORATORY_KEY
      );
      return storedVisitedSettingLaboratory == "true" ? true : false;
    });
  const [hasVisitedHistoryLaboratory, setHasVisitedHistoryLaboratory] =
    useState<boolean>(() => {
      const storedVisitedHistoryLaboratory = localStorage.getItem(
        VISITED_HISTORY_LABORATORY_KEY
      );
      return storedVisitedHistoryLaboratory == "true" ? true : false;
    });
  const [hasAddedNewTicket, setHasAddedNewTicket] = useState<number>(() => {
    const storedAddedNewTicket = localStorage.getItem(ADDED_NEW_TICKET_KEY);
    return storedAddedNewTicket == "2"
      ? 2
      : storedAddedNewTicket == "1"
        ? 1
        : 0;
  });
  const [hasVisitedTicketList, setHasVisitedTicketList] = useState<boolean>(
    () => {
      const storedVisitedTicketList = localStorage.getItem(
        VISITED_TICKET_LIST_KEY
      );
      return storedVisitedTicketList == "true" ? true : false;
    }
  );
  const [
    hasVisitedSendVerifyAccessLocation,
    setHasVisitedSendVerifyAccessLocation,
  ] = useState<boolean>(() => {
    const storedVisitedSendVerifyAccessLocation = localStorage.getItem(
      VISITED_SEND_VERIFY_ACCESS_LOCATION_KEY
    );
    return storedVisitedSendVerifyAccessLocation == "true" ? true : false;
  });

  const [hasVisitedVerifyAccessLocation, setHasVisitedVerifyAccessLocation] =
    useState<boolean>(() => {
      const storedVisitedVerifyAccessLocation = localStorage.getItem(
        VISITED_VERIFY_ACCESS_LOCATION_KEY
      );
      return storedVisitedVerifyAccessLocation == "true" ? true : false;
    });

  const [hasVisitedDeviceHistoryLocation, setHasVisitedDeviceHistoryLocation] =
    useState<boolean>(() => {
      const storedVisitedDeviceHistoryLocation = localStorage.getItem(
        VISITED_DEVICE_HISTORY_LOCATION_KEY
      );
      return storedVisitedDeviceHistoryLocation == "true" ? true : false;
    });

  const [hasVisitedDeviceControlLocation, setHasVisitedDeviceControlLocation] =
    useState<boolean>(() => {
      const storedVisitedDeviceControlLocation = localStorage.getItem(
        VISITED_DEVICE_CONTROL_LOCATION_KEY
      );
      return storedVisitedDeviceControlLocation == "true" ? true : false;
    });

  const [hasVisitedDeviceRequestSMSSent, setHasVisitedDeviceRequestSMSSent] =
    useState<boolean>(() => {
      const storedVisitedDeviceRequestSMSSent = localStorage.getItem(
        VISITED_DEVICE_REQUEST_SMS_SENT_KEY
      );
      return storedVisitedDeviceRequestSMSSent == "true" ? true : false;
    });

  const [
    hasVisitedLackOfWalletDeviceRequestSMSSent,
    setHasVisitedLackOfWalletDeviceRequestSMSSent,
  ] = useState<boolean>(() => {
    const storedVisitedLackOfWalletDeviceRequestSMSSent = localStorage.getItem(
      VISITED_LACK_OF_WALLET_DEVICE_REQUEST_SMS_SENT_KEY
    );
    return storedVisitedLackOfWalletDeviceRequestSMSSent == "true"
      ? true
      : false;
  });

  // First Login Begin

  const setFirstLoginStatus = (status: boolean) => {
    setIsFirstLogin(status);
    localStorage.setItem(FIRST_LOGIN_KEY, status.toString());
  };
  //First Login End

  //devices Begin
  const setVisitedListDevices = (status: boolean) => {
    setHasVisitedListDevices(status);
    localStorage.setItem(VISITED_LIST_DEVICES_KEY, status.toString());
  };

  const setAddedNewDevice = (status: number) => {
    setHasAddedNewDevice(status);
    localStorage.setItem(ADDED_NEW_DEVICE_KEY, status.toString());
  };
  //devices End

  //operations Begin

  const setAddedNewOperation = (status: number) => {
    setHasAddedNewOperation(status);
    localStorage.setItem(ADDED_NEW_OPERATION_KEY, status.toString());
  };
  const setVisitedListOperations = (status: boolean) => {
    setHasVisitedListOperations(status);
    localStorage.setItem(VISITED_LIST_OPERATIONS_KEY, status.toString());
  };
  //operations End

  //device serials Begin

  const setAddedNewDeviceSerial = (status: number) => {
    setHasAddedNewDeviceSerial(status);
    localStorage.setItem(ADDED_NEW_DEVICE_SERIALS_KEY, status.toString());
  };
  const setVisitedListDeviceSerials = (status: boolean) => {
    setHasVisitedListDeviceSerials(status);
    localStorage.setItem(VISITED_LIST_DEVICE_SERIALS_KEY, status.toString());
  };
  //device serials End

  //device Message Begin
  const setAddedNewDeviceMessage = (status: number) => {
    setHasAddedNewDeviceMessage(status);
    localStorage.setItem(ADDED_NEW_DEVICE_MESSAGE_KEY, status.toString());
  };
  const setVisitedListDeviceMessage = (status: boolean) => {
    setHasVisitedListDeviceMessage(status);
    localStorage.setItem(VISITED_LIST_DEVICE_MESSAGE_KEY, status.toString());
  };
  //device Message End
  //Analyze Laboratory Begin

  const setAddedNewAnalyzeFile = (status: number) => {
    setHasAddedNewAnalyzeFile(status);
    localStorage.setItem(ADDED_NEW_ANALYZE_FILE_KEY, status.toString());
  };
  const setVisitedAnalyzeLaboratory = (status: boolean) => {
    setHasVisitedAnalyzeLaboratory(status);
    localStorage.setItem(VISITED_ANALYZE_LABORATORY_KEY, status.toString());
  };
  //Analyze Laboratory End
  //Generate Laboratory Begin

  const setAddedNewGenerateFile = (status: number) => {
    setHasAddedNewGenerateFile(status);
    localStorage.setItem(ADDED_NEW_GENERATE_FILE_KEY, status.toString());
  };
  const setVisitedGenerateLaboratory = (status: boolean) => {
    setHasVisitedGenerateLaboratory(status);
    localStorage.setItem(VISITED_GENERATE_LABORATORY_KEY, status.toString());
  };
  //Generate Laboratory End
  //Console Send Verify Access Begin

  const setVisitedSendVerifyAccess = (status: boolean) => {
    setHasVisitedSendVerifyAccess(status);
    localStorage.setItem(VISITED_SEND_VERIFY_ACCESS_KEY, status.toString());
  };
  //Console Send Verify Access End
  //Console Verify Access Begin

  const setVisitedFileManagerList = (status: boolean) => {
    setHasVisitedFileManagerList(status);
    localStorage.setItem(VISITED_FILE_MANAGER_LIST, status.toString());
  };

  const setVisitedAnalyzerOverview = (status: boolean) => {
    setHasVisitedAnalyzerOverview(status);
    localStorage.setItem(VISITED_ANALYZER_OVERVIEW, status.toString());
  };

  const setVisitedDeviceUpdateList = (status: boolean) => {
    setHasVisitedDeviceUpdateList(status);
    localStorage.setItem(VISITED_DEVICE_UPDATE_LIST, status.toString());
  };

  const setShowDownloadLinkValue = (status: boolean) => {
    setShowDownloadLink(status);
    localStorage.setItem(SHOW_DOWNLOAD_LINK, status.toString());
  };

  const setVisitedVerifyAccess = (status: boolean) => {
    setHasVisitedVerifyAccess(status);
    localStorage.setItem(VISITED_VERIFY_ACCESS_KEY, status.toString());
  };
  //Console Verify Access End
  //Console MQTT connection Begin

  const setVisitedMqttConnection = (status: boolean) => {
    setHasVisitedMqttConnection(status);
    localStorage.setItem(VISITED_MQTT_CONNECTION_KEY, status.toString());
  };
  //Console MQTT connection End
  //console Setting Laboratory Begin

  const setVisitedSettingLaboratory = (status: boolean) => {
    setHasVisitedSettingLaboratory(status);
    localStorage.setItem(VISITED_SETTING_LABORATORY_KEY, status.toString());
  };
  //console Setting Laboratory End

  //console History Laboratory Begin

  const setVisitedHistoryLaboratory = (status: boolean) => {
    setHasVisitedHistoryLaboratory(status);
    localStorage.setItem(VISITED_HISTORY_LABORATORY_KEY, status.toString());
  };
  //console History Laboratory End

  //ticket Begin

  const setAddedNewTicket = (status: number) => {
    setHasAddedNewTicket(status);
    localStorage.setItem(ADDED_NEW_TICKET_KEY, status.toString());
  };
  const setVisitedTicketList = (status: boolean) => {
    setHasVisitedTicketList(status);
    localStorage.setItem(VISITED_TICKET_LIST_KEY, status.toString());
  };
  //ticket End

  // history GPS device location Begin
  const setVisitedDeviceHistoryLocation = (status: boolean) => {
    setHasVisitedDeviceHistoryLocation(status);
    localStorage.setItem(
      VISITED_DEVICE_HISTORY_LOCATION_KEY,
      status.toString()
    );
  };
  // history GPS device location End

  //control GPS Device Location Begin
  const setVisitedDeviceControlLocation = (status: boolean) => {
    setHasVisitedDeviceControlLocation(status);
    localStorage.setItem(
      VISITED_DEVICE_CONTROL_LOCATION_KEY,
      status.toString()
    );
  };
  //control GPS Device Location End

  // verify access Location Begin
  const setVisitedSendVerifyAccessLocation = (status: boolean) => {
    setHasVisitedSendVerifyAccessLocation(status);
    localStorage.setItem(
      VISITED_SEND_VERIFY_ACCESS_LOCATION_KEY,
      status.toString()
    );
  };
  const setVisitedVerifyAccessLocation = (status: boolean) => {
    setHasVisitedVerifyAccessLocation(status);
    localStorage.setItem(VISITED_VERIFY_ACCESS_LOCATION_KEY, status.toString());
  };
  // verify access Location End

  // device Request sms and lack Begin
  const setVisitedDeviceRequestSMSSent = (status: boolean) => {
    setHasVisitedDeviceRequestSMSSent(status);
    localStorage.setItem(
      VISITED_DEVICE_REQUEST_SMS_SENT_KEY,
      status.toString()
    );
  };

  const setVisitedLackOfWalletDeviceRequestSMSSent = (status: boolean) => {
    setHasVisitedLackOfWalletDeviceRequestSMSSent(status);
    localStorage.setItem(
      VISITED_LACK_OF_WALLET_DEVICE_REQUEST_SMS_SENT_KEY,
      status.toString()
    );
  };
  // device Request sms and lack end

  const contextValue: FirstLoginContextType = {
    //
    isFirstLogin,
    setFirstLoginStatus,
    //
    hasVisitedListDevices,
    setVisitedListDevices,
    hasAddedNewDevice,
    setAddedNewDevice,
    //
    hasAddedNewOperation,
    setAddedNewOperation,
    setVisitedListOperations,
    hasVisitedListOperations,
    //
    hasAddedNewDeviceSerial,
    setAddedNewDeviceSerial,
    setVisitedListDeviceSerials,
    hasVisitedListDeviceSerials,
    //
    hasAddedNewDeviceMessage,
    setAddedNewDeviceMessage,
    setVisitedListDeviceMessage,
    hasVisitedListDeviceMessage,
    //
    hasAddedNewAnalyzeFile,
    setAddedNewAnalyzeFile,
    hasVisitedAnalyzeLaboratory,
    setVisitedAnalyzeLaboratory,
    //
    hasAddedNewGenerateFile,
    setAddedNewGenerateFile,
    hasVisitedGenerateLaboratory,
    setVisitedGenerateLaboratory,
    //
    hasVisitedSendVerifyAccess,
    setVisitedSendVerifyAccess,
    //
    hasVisitedVerifyAccess,
    setVisitedVerifyAccess,
    //
    hasVisitedMqttConnection,
    setVisitedMqttConnection,
    //
    hasVisitedSettingLaboratory,
    setVisitedSettingLaboratory,
    //
    hasVisitedHistoryLaboratory,
    setVisitedHistoryLaboratory,
    //
    hasAddedNewTicket,
    setAddedNewTicket,
    setVisitedTicketList,
    hasVisitedTicketList,
    //
    hasVisitedSendVerifyAccessLocation,
    setVisitedSendVerifyAccessLocation,
    hasVisitedVerifyAccessLocation,
    setVisitedVerifyAccessLocation,
    //
    hasVisitedDeviceHistoryLocation,
    setVisitedDeviceHistoryLocation,
    //
    hasVisitedDeviceControlLocation,
    setVisitedDeviceControlLocation,
    //
    hasVisitedDeviceRequestSMSSent,
    setVisitedDeviceRequestSMSSent,
    //
    hasVisitedLackOfWalletDeviceRequestSMSSent,
    setVisitedLackOfWalletDeviceRequestSMSSent,
    //
    hasVisitedFileManagerList,
    setVisitedFileManagerList,
    //
    hasVisitedAnalyzerOverview,
    setVisitedAnalyzerOverview,
    //
    hasVisitedDeviceUpdateList,
    setVisitedDeviceUpdateList,
    //
    showDownloadLink,
    setShowDownloadLinkValue
  };

  return (
    <FirstLoginContext.Provider value={contextValue}>
      {children}
    </FirstLoginContext.Provider>
  );
};
